import { Card, CardContent, Typography, Grid, Box } from "@mui/material";

const ItemCard = ({ saleNet, saleTotal,saleVat }) => {

  const summary = [
      { label: "Sale Total", value: saleTotal, color: "primary.main" },
      { label: "Sale Vat", value: saleVat, color: "success.main" },
      { label: "Sale Net", value: saleNet, color: "error.main" },
  ];

  return (
    <Card sx={{ borderRadius: 1, boxShadow: 1, p: 1 }}>
      <CardContent>
        <Grid container spacing={2}>
          {summary.map((item, idx) => (
            <Grid item xs={12} sm={4} key={idx}>
              <Box
                sx={{
                  borderRadius: 2,
                  bgcolor: "grey.100",
                  p: 1,
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ color: "text.secondary", mb: 1 }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: item.color, fontWeight: "bold" }}
                >
                  {item.value.toLocaleString()}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ItemCard;
